import { modernThemes, extraThemes, screenModes } from './const.mjs';

const isThemeModern = theme => modernThemes.includes(theme);
const isExtraTheme = theme => extraThemes.includes(theme);
const isForestGreenTheme = theme => theme === extraThemes[0];
const isScreenModeDark = (theme, screenMode) => isThemeModern(theme) && screenModes[1] === screenMode;
const getThemeClassName = (theme, screenMode) => {
  if (!isThemeModern(theme)) {
    return `np-theme-${theme || 'personal'}`;
  }
  let classes = `np-theme-personal`;
  if (isExtraTheme(theme)) {
    classes += ` ${classes}--${theme}`;
  } else if (screenModes[1] === screenMode) {
    classes += ` ${classes}--${screenMode}`;
  }
  return classes;
};

export { getThemeClassName, isExtraTheme, isForestGreenTheme, isScreenModeDark, isThemeModern };
//# sourceMappingURL=helpers.mjs.map
